import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import getNameFromEmail from "/src/utils/getNameFromEmail";
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter";
import "./UserCell.css";

function UserCell({ email }) {
    const toast = useToastDispatchContext();

    if (!email) {
        return <span className="log-user-cell_system">System</span>;
    }

    const { firstName, lastName } = getNameFromEmail(email);
    const displayName = [firstName, lastName].filter(Boolean).map(capitalizeFirstLetter).join(" ") || email;

    const copyEmail = () => {
        navigator.clipboard.writeText(email).then(() => {
            toast.success("Copy to clipboard", "You can paste this email where you need !", 5000);
        });
    };

    return (
        <span className="log-user-cell" onClick={copyEmail} title="Click to copy email">
            {displayName}
        </span>
    );
}

export default UserCell;
